import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {convertSecondsToMMSSFormat} from '@Utils/date.util';
import {useAppSelector} from '@/hooks';

export function CurrentTimeText(): ReactElement {
  const currentPageTime = useAppSelector((state) => {
    return state.posterEditor.currentTime;
  });
  const getCurrentTime = (): ReactElement => {
    return (
      <>
        <Text val={`${convertSecondsToMMSSFormat(currentPageTime)} /`} size={TextSize.XXSMALL} />
        &nbsp;
      </>
    );
  };

  return getCurrentTime();
}
